import ColumnBase from "./ColumnBase.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ICON_COL_DEF_WIDTH, SwivuDocumentType } from "../../other/constants/OtherKeys.jsx";
import { defaultGroupRenderer } from "../../other/utils/utils.jsx";
import { HasIconColumnTooltipMixin } from "./mixins/HasIconColumnTooltipMixin.jsx";

const getEntityIcon = (hasData = false) => {
  const color = hasData ? "text-[#0a88e9]" : "";
  return `<i class="swivu-media-icon-tooltip fa-regular fa-folder-open ${color}"></i>`;
};

export default class FilesColumn extends HasIconColumnTooltipMixin(ColumnBase) {
  static get $name() {
    return "FilesColumn";
  }

  static get type() {
    return WIDGET_KEYS.filesColumn;
  }

  static get defaults() {
    return {
      text: "File",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      field: "hasFiles",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      renderer({ value }) {
        return getEntityIcon(value);
      },
      groupRenderer({ groupRowFor, ...rest }) {
        return defaultGroupRenderer({ groupRowFor: getEntityIcon(groupRowFor), ...rest });
      },
      headerRenderer() {
        return getEntityIcon();
      }
    };
  }

  getTooltipSelector() {
    return ".swivu-media-icon-tooltip";
  }

  getTooltipItems(record) {
    const fileRecords = this.project.boardFilesStore.query(file => {
      if (record.isTask || record.isPlanTaskModel) return file.taskId === record.id;
      if (record.isResource) return file.resourceId === record.id;
      if (record.isClient) return file.clientId === record.id;

      return false;
    });

    return fileRecords;
  }

  formatTooltipItems(records) {
    return records.map((record) => {
      const originalRecord = record
      record = record.swivuDocumentRecordMapping;
      // Limit description to a reasonable length
      const description = record.name || "";
      const truncatedDescription = description.length > 50 ?
        description.substring(0, 50) + "..." : description;

      return {
        tag: "div",
        dataset: {
          documentId: originalRecord.id,
          source: record.source,
        },
        class: "tooltip-contact-container",
        children: [
          {
            tag: "div",
            class: "contact-pill contact-header",
            text: truncatedDescription || "Untitled File",
            html: `
              <div class="flex items-center gap-[0.5em]">
                <img
                  src="${record.thumbnailImageUrl}" alt="${record.name}" width="40px" height="40px" style="border-radius: 4px; min-width: 40px; min-height: 40px"
                  onerror="this.src='https://www.iconpacks.net/icons/2/free-file-icon-1453-thumb.png'"
                />
                <div style="overflow: hidden">
                  <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden">${truncatedDescription || "Untitled Media"}</div>
                  <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden" class="swivu-tooltip-pill-item mt-[0.5em]">Added By: ${record.addedBy || 'N/A'}</div>
                </div>
              </div>
            `,
          }
        ]
      };
    });
  }

  handleTooltipClick(event, _record) {
    if (this.onDocumentTimeout) clearTimeout(this.onDocumentTimeout);

    this.onDocumentTimeout = setTimeout(() => {
      const tooltipFileContainerEl = event.target.closest(".tooltip-contact-container");

      if (tooltipFileContainerEl && (+tooltipFileContainerEl.dataset.source) === SwivuDocumentType.swivuFile) {
        const fileRecord = this.project.boardFilesStore.getById(tooltipFileContainerEl.dataset.documentId);
        if (!fileRecord) return;

        window.open(fileRecord.url, '_blank');
      }
    }, 100);
  }
}

ColumnStore.registerColumnType(FilesColumn);
